<template>
	<!-- 查看弹窗 -->
	<div v-if="viewData&&viewData.isShow">
	    <div class="mask check-log" v-if="!isDetailsShow">
	        <div class="e-modal medium">
	            <div class="e-modal-title">查看 <i class="e-modal-close" @click="viewData.isShow=false"></i></div>
	            <div class="e-modal-body details-wt-table">
	                <table class="check-log-table" cellspacing="0">
	                    <tr>
	                        <td>序号</td>
	                        <td>采购单号</td>
	                        <td>付款银行</td>
	                        <td>付款卡号</td>
	                        <td>付款金额</td>
	                        <td>操作时间</td>
	                    </tr>
	                    <tbody  v-for="(item,index) in list">
	                   	<tr>
	                    	<td>{{index+1}}</td>
	                        <td>{{item.OrderNO}}</td>
	                        <td>{{item.SupBankName}}</td>
	                        <td>{{item.SupBankAccount}}</td>
	                        <td>{{item.Amount}}</td>
	                        <td>{{item.Date|dateLong}}</td>
	                    </tr>
	                    <tr>
	                    	<td colspan="6">
	                    		<img :src="item.EevidenceImg"></td>
	                    	</td>
	                    </tr>
	                    <tr>
	                    	<td colspan="6">
	                    		<div class="review-details-btn" @click="showDetails(item)">
	                    			查看水单付款明细
	                    		</div>
	                    	</td>
	                    </tr>
	                    </tbody>

	                    <tr v-if="!list||list.length<=0">
	                    	<td colspan="7">没有相关数据</td>
	                    </tr>
	                </table>
	            </div>
	        </div>
	    </div>


	    <div class="mask check-log" v-if="isDetailsShow">
	        <div class="e-modal medium">
	            <div class="e-modal-title">水单明细 <i class="e-modal-close" @click="isDetailsShow=false"></i></div>
	            <div class="e-modal-body details-wt-table">
	                <table class="check-log-table " cellspacing="0">
	                    <tr>
	                        <td>采购单号</td>
	                        <td>酒店</td>
	                        <td>入住人姓名</td>
	                        <td>付款银行/付款卡号</td>
	                        <td>付款金额</td>
	                        <td>操作时间</td>
	                    </tr>
	                    <tbody  v-for="(item,index) in detailsList">
	                   	<tr>
	                    	
	                        <td>{{item.OrderNO}}</td>
	                        <td>{{item.SupName}}</td>
	                        <td>{{item.Guests}}</td>
	                        <td>
	                        	{{item.SupBankName}}</br>
	                        	{{item.SupBankAccount}}
	                    	</td>
	                        <td>{{item.Amount}}</td>
	                        <td>{{item.Date|dateLong}}</td>

	                    </tr>
	             
	                    </tbody>

	                    <tr v-if="!detailsList||detailsList.length<=0">
	                    	<td colspan="7">没有相关数据</td>
	                    </tr>
	                </table>
	            </div>
	        </div>
	    </div>



    </div>
</template>
<script>
export default {
	name: 'paymentView',
	props:{
        vdata: {
            type: Object,
 			default: function(){
                return {}
            }
        }
  	},
  	data(){
  		return {
  			viewData:{},
  			list:[],
  			detailsList:[],
  			isDetailsShow:false
  		}
  	},
  	watch:{
  		vdata(val){
  			this.viewData=val;
  			this.initData();
  		}
  	},
  	methods:{

  		showDetails(item){
			
			var that=this;
			that.isDetailsShow=true;
	        var params={
	          paymentid: item.PaymentID
	        }
	        that.getRequest({
	            url: that.Api.getPaymentsByPaymentID,
	            params: params
	        }).then(res => {
	        	
	        	if(res&&res.Result.length>0){
	        		this.detailsList = res.Result;
	        	}else{
	        		this.detailsList = [];
	        	}
	        });
			
  		},
  		initData(){
  			var that=this;
	        var params={
	          supOrderNO: that.viewData.MainOrderId
	        }
	        that.getRequest({
	            url: that.Api.getPaymentsByOrderNO,
	            params: params
	        }).then(res => {
	        	if(res&&res.Result.length>0){
	        		that.list=res.Result;
	        	}else{
	        		// that.error({ title: '提示', content: '没有查询到相关数据' });
	        	}
	        });
  		}

  	}


}
</script>


// WEBPACK FOOTER //
// src/components/payment/paymentView.vue